<template>
  <div class="news">
    <div class="news-nav">
      <div class="news-nav-content">
        <div class="news-nav-content-left">
          <div @click="goBack">项目案例</div>
          <div>&gt;</div>
          <div>{{detail.title}}</div>
        </div>
        <div class="news-nav-content-right" @click="goBack">返回</div>
      </div>     
    </div>
    <div class="news-center">
       <div class="news-center-top">
         <img :src="fileUrl+detail.thumb+affix" alt="">
         <div class="news-center-top-title">
           <div>{{detail.title}}</div>
           <div>
             <div>产品服务</div>
             <div v-for="(s,j) in detail.tags" :key="j">{{s}}</div>
           </div>
           <div>
             {{detail.description}}
           </div>
         </div>
       </div>
       <div class="news-center-center">
          <div class="news-center-center-img">
            <div v-for="(item,index) in detail.produces" :key="index">
              <img :src="fileUrl+item.img+affix" alt="">
              <div>{{item.name}}</div>
            </div>
          </div>
       </div>
       <div class="news-center-foot">
          <div class="news-center-foot-content">{{detail.content}}</div>
       </div>
    </div>
    <div class="news-foot">
      <div>项目合作咨询</div>
      <div>关于测绘和模型的更多咨询， 请联系我们</div>
      <div @click="goDetail">联系我们</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data(){
    return {
      detail:{
        img:require(`../../assets/img/project1.png`),
        title:'2016年上海新场镇民宿改造项目勘察测绘',
        productType:['地理信息服务','三维模型制作','古建数字化','立面监测','工程探测'],
        content:'地形平面、室内户型、室外门窗、屋顶、重点苗木', //工作内容
        imgs:[
          {
            name:'位置',
            url:require(`../../assets/img/project/1-1.png`)
          },
          {
            name:'平面图（内部户型及门窗）',
            url:require(`../../assets/img/project/1-2.png`)
          },
          {
            name:'屋顶平面图',
            url:require(`../../assets/img/project/1-3.png`)
          },
        ], 
        projectDuration:'位于上海新场镇，占地面积8000平米，工期10天。',//项目工期
        instrument:'三组人员，采用了全站仪、GPS、手持测距仪、三维激光扫描仪'//仪器设置
      }
    }
  },
  computed: {
    ...mapState('showData', ['fileUrl']),
  },
  created(){
    this.affix = `?Tenant=${localStorage.getItem('Tenant')}`
  },
  mounted(){
    console.log(this.$route.params.detail);
    if(this.$route.params.detail===undefined){
      this.$router.push({name:'project'})
      return 
    }
    this.detail=this.$route.params.detail
  },
  methods:{
    changeIndex(i){
      this.currentIndex = i
    },  
    goBack(){
      this.$router.push({name:'project'})
    } , 
    goDetail(){
       this.$router.push({name:'contact'})
    }
  },
  filters: {
    dataFormat(date,type) {
      let day=date.split("T")[0].split("-")
      if (type == 'd') { //返回天
        return day[2];
      } else { //返回日月
        return day[1]+','+day[0];
      }
        
    }
  }
};
</script>

<style lang="scss" scoped>
.news{
  width:100%;
  height: auto;
  box-sizing: border-box;
  background: #F6F6F6;
  &-nav{
    width: 100%;
    margin: auto;
    padding: 0.3rem 0;
    background: #fff;
    // margin-bottom: 0.5rem;
    &-content{
      width: 12rem;
      margin: auto;      
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.13rem;
      color: #999;
      &-left{
        display: flex;
        align-items: center;
        >div{
          margin: 0 0.1rem;          
        }
        >div:nth-child(1){
          cursor: pointer;
        }
        >div:nth-child(1):hover{
          color: #FFBE00;
        }
      }
      &-right{
        cursor: pointer;
      }
      &-right:hover{
        color: #FFBE00;
      }
    }
    
  }
  &-center{
    width: 100%;
    margin: auto;    
    &-top{
      display: flex;
      align-items: center;
      img{
        width: 7.78rem;
        height: 3.2rem;
      }
      &-title{
        width: calc(100% - 7.8rem);
        height: 3.2rem;
        background: #FFFCF5;
        >div:nth-child(1){
          font-size: 0.19rem;
          font-weight: 500;
          color: #000;
          margin: 0.8rem 0 0.4rem 0.6rem;
        }
        >div:nth-child(2){
          display: flex;
          align-items: center;
          font-size: 0.13rem;
          margin: 0.4rem 0 0.4rem 0.6rem;
          >div{
            margin-right: 0.2rem;
          }
          >div:nth-child(n+2){
            color: #FFBE00;
          }
        }
        
      }
    }
    &-center{
      width: 12rem;
      margin: auto;
      &-img{
        width: 100%;
        display: flex;
        align-items: center;
        margin: 0.4rem 0;
        >div{
          border: 1px solid rgba(0,0,0,0.12);
          width: 3.65rem;
          min-height: 3.11rem;
          text-align: center;
          font-size: 0.14rem;
          color: #666666;
          margin-right: 0.3rem;
          >img{
            width: 100%;
            height: 2.63rem;
          }
          >div{
            margin-top: 0.15rem;
          }
        }
      }
    }
    &-foot{
      width: 12rem;
      margin: auto;
      &-title{
        font-size: 0.23rem;
        color: #262626;
        font-weight: 500;
        margin-bottom: 0.2rem;
      }
      &-content{
        font-size: 0.14rem;
        color: #333333;
        margin-bottom: 0.6rem;
      }
    }
  }
  &-foot{
    width: 100%;
    height: 2.36rem;
    background: #FFBE00;
    text-align: center;
    color: #fff;
    font-weight: 400;
    >div:nth-child(1){
      font-size: 0.31rem;
      padding-top: 0.4rem;
    }
    >div:nth-child(2){
      font-size: 0.15rem;
      padding-top: 0.2rem;
    }
    >div:nth-child(3){
      width: 1.6rem;
      height: 0.44rem;
      line-height: 0.44rem;
      text-align: center;
      border: 1px solid #fff;
      font-size: 0.16rem;
      margin:0.3rem auto;
      cursor: pointer;
    }
  }
}
</style>
